import { Flax } from "../../resources/sewing";
import { Building } from "../../types";

const FarmShed: Building = {
  name: "Farm Shed",
  items: [Flax,],
}

export default FarmShed